// extracted by mini-css-extract-plugin
export default {"container":"Canvas_container__N0pPQ","navbar_container":"Canvas_navbar_container__uNMDi","editor_container":"Canvas_editor_container__8Dv8f"};